import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Grid,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import BaggageRoute from './BaggageRoute';

const BaggageAccordion = ({
  borderColor,
  passenger,
  expanded,
  onChange,
  services,
  selectedBaggage,
  onBaggageSelect,
}) => {
  return (
    <Accordion
      elevation={0}
      expanded={expanded}
      onChange={onChange}
      sx={{
        border: `1px solid ${borderColor}`,
        '&:before': { display: 'none' },
        borderRadius: '8px !important',
        mb: 2,
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{ color: borderColor }} />}
        sx={{
          '& .MuiAccordionSummary-content': {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            width: '100%',
            m: 0,
          },
        }}
      >
        <Box
          sx={{
            width: 28,
            height: 28,
            borderRadius: '50%',
            border: `2px solid ${borderColor}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mr: 2,
          }}
        >
          <Typography sx={{ color: borderColor }} variant='body2'>
            {passenger.number}
          </Typography>
        </Box>
        <Typography variant='body1'>
          Pasajero{' '}
          <Typography color='text.secondary' component='span' variant='body2'>
            {passenger.type}
          </Typography>
        </Typography>
      </AccordionSummary>

      <AccordionDetails sx={{ p: 2 }}>
        <Grid container spacing={2}>
          {passenger.routes.map((route, index) => {
            const handBaggage = route.baggage.filter((b) => b.category === 'HandBaggage');
            const checkedBaggage = route.baggage.filter((b) => b.category === 'Baggage');

            return (
              <Grid item key={index} md={6} xs={12}>
                <BaggageRoute
                  checkedBaggage={checkedBaggage}
                  color={borderColor}
                  direction={route.direction}
                  handBaggage={handBaggage}
                  journeyRef={route.journeyRef}
                  key={`${route.journeyRef}+${passenger.id}+${index}`}
                  onBaggageSelect={onBaggageSelect}
                  passengerId={passenger.id}
                  route={route.route}
                  selectedServices={selectedBaggage[route.journeyRef]}
                  services={services}
                />
              </Grid>
            );
          })}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default BaggageAccordion;
